export default [{
  path: '/order',
  name: 'order',
  component: () => import('@/pages/order/index'),
  meta: {
    spm: 2283,
  },
}];
